## html
<bpnode-header-info class="bphead-{{ type }}" title="{{ description }}">{{ text }}</bpnode-header-info>

## scss-global
bpnode-header-info {
	bottom: 24px;
	position: relative;
	padding: 5px 7px;
	border-radius: 10px;
	font-size: 16px;

	&.bphead-error{
		box-shadow: 0 0 12px red;
		border: 1px solid red;
		background: #ff0000c7;
	}

	&.bphead-info{
		box-shadow: 0 0 12px white;
		border: 1px solid white;
		color: black;
		background: #ffffffc7;
	}

	&.bphead-warn{
		box-shadow: 0 0 12px #fff700;
		border: 1px solid #fff700;
		background: #fff70096;
		color: black;
	}

	&.bphead-success{
		box-shadow: 0 0 12px #62ff00;
		background: #62ff00c7;
		color: black;
	}
}

## js-global
Blackprint.space.component('bpnode-header-info', {
	template: #this.path
}, function(My){
	My.type = "info";
	My.text = "";
	My.description = "";

	// Mark this element as cloneable for Blackprint Sketch
	My.$cloneable = true;
});